// "Missed (Billable)" is not used in the workflow any more, so it is hidden
// from every status list a user can pick from (calendar legends, status
// dropdowns and grid filters). The status itself is kept in the enum so that
// sessions saved with it earlier are still labelled correctly.
export const HIDDEN_SEANCE_STATUSES = [8];

export const isHiddenSeanceStatus = (status: string | number) => HIDDEN_SEANCE_STATUSES.includes(+status);

export const withoutHiddenStatuses = (items: SelectObject[]): SelectObject[] =>
    items.filter((it) => !isHiddenSeanceStatus(it.value));
